import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HeaderArea from "@/components/HeaderArea";
import CopyRight from "@/components/CopyRight";
import {onMounted, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mobile = ref<boolean>(true)
const mobileMenuOpened = ref(false)

onMounted(() => {
  window.addEventListener('resize', checkScreen);
  checkScreen();
})

function checkScreen(){
  if(window.innerWidth <= 672){
    mobile.value = true
    return
  }
  mobile.value = false
  mobileMenuOpened.value = false
}

function changeMobileMenuOpenedState(){
  mobileMenuOpened.value = !mobileMenuOpened.value
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'bodyMaxHeight': mobileMenuOpened.value})
  }, [
    _createVNode(_unref(HeaderArea), {
      onChange: changeMobileMenuOpenedState,
      mobile: mobile.value,
      mobileMenuOpened: mobileMenuOpened.value
    }, null, 8, ["mobile", "mobileMenuOpened"]),
    _createElementVNode("div", {
      class: _normalizeClass(["contentArea", {'maxHeight': mobileMenuOpened.value}])
    }, [
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(_unref(CopyRight))
  ], 2))
}
}

})